module.exports = __webpack_public_path__ + "static/media/Flow-back-arrow-white.5654b191.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/Flow-back-arrow-white.svg
// module id = 809
// module chunks = 0